import { Container } from "react-bootstrap";
import ContactBox from "./ContactBox";
import {
  FaFacebookMessenger,
  FaPhone,
  FaVideo,
  FaVoicemail,
} from "react-icons/fa";
import RoundedImg from "../RoundedImg";
import Heading from "../Heading";
import infoContact from "./Contact.json";

const Contact = () => {
  const headingTagData = {
    h2: "Contact Us",
    h3: "Easy to contact us",
    p: "We always ready to help by providijng the best services for you. We beleive a good blace to live can make your life better",
  };
  const getIconComponent = (iconName) => {
    switch (iconName) {
      case "FaFacebookMessenger":
        return <FaFacebookMessenger />;
      case "FaPhone":
        return <FaPhone />;
      case "FaVideo":
        return <FaVideo />;
      case "FaVoicemail":
        return <FaVoicemail />;
      default:
        return null;
    }
  };
  const ContactInfo = infoContact.map((e, i) => {
    const IconComponent = getIconComponent(e.iconName);
    return (
      <div className=" col-sm-6" key={i}>
        <ContactBox icon={IconComponent} btn={e.btn} num={e.num} />
      </div>
    );
  });
  return (
    <section className="pt-5">
      <Container>
        <div className="row align-items-center justify-content-between">
          <div className="col-lg-6 mb-5">
            <Heading
              h2={headingTagData.h2}
              h3={headingTagData.h3}
              p={headingTagData.p}
            />
            <div className="row justify-content-between">{ContactInfo}</div>
          </div>
          <RoundedImg img={require("../../imgs/hero-image.png")} />
        </div>
      </Container>
    </section>
  );
};

export default Contact;
